import _ from 'lodash';
import PropTypes from 'prop-types';
import { SVG_PROP_TYPE } from '../vectorImage/constants';
import SIZES_JSON from '../iconography/iconography_sizes.json';
export var GRAPHIC_SIZES = _.chain(SIZES_JSON).keys().filter(function (size) {
  return size.indexOf('graphic-') >= 0;
}).map(function (size) {
  return size.replace('graphic-', '').replace('halo-', '');
}).uniq().value(); // PropTypes

export var GRAPHIC_TYPE_PROP_TYPE = SVG_PROP_TYPE;
export var GRAPHIC_SIZE_PROP_TYPE = PropTypes.oneOf(GRAPHIC_SIZES);